window.addEventListener('DOMContentLoaded', function () {
	document.querySelector('.navbar-toggler').addEventListener('click', function () {
		menuState = !menuState
		if (menuState) { document.body.classList.add('prevent-scroll') } else { document.body.classList.remove('prevent-scroll') }
	})

	document.querySelector('#navbar-overlay').addEventListener('click', function () {
		menuState = !menuState
		$('#menu').collapse('hide')
		document.body.classList.remove('prevent-scroll')
	})

	if (document.querySelector('.dropdown-menu')) {
        var dropdownmenu = document.querySelectorAll('.dropdown-menu')
        dropdownmenu.forEach(element => {
            element.addEventListener('click', function (e) {
                e.stopPropagation()
            })
        })
    }

	var menuState = false
	var mouseDown = false
	var startX = 0
	var startY = 0
	var moveRight = 0
	var moveBottom = 0
	var firstScroll = 0
	var open = 0 // 0 - nie otwieraj ; 1 - otwieraj ; -1 - zamykaj
	var menuSize	= 300 // szerokość naszego menu w pixelach (wartość domyślna)
	var PAGE_CHANGE_MENU_ON_MOBILE = 1200 // wartość na której zmienia się wygląd menu na rozwijane
	var menuDOMElement = document.querySelector('#menu')
	var timeOutClass

	if (window.screen.width < PAGE_CHANGE_MENU_ON_MOBILE) {
		menuDOMElement.classList.add('transition-standard')
		window.addEventListener('touchstart', touchScreen)
		window.addEventListener('touchend', touchEnd)
		window.addEventListener('touchmove', moveOnScreen)
	}

	window.addEventListener('resize', function () {
		if (window.screen.width < PAGE_CHANGE_MENU_ON_MOBILE) {
			timeOutClass = setTimeout(function () { menuDOMElement.classList.add('transition-standard') }, 500)
			window.addEventListener('touchstart', touchScreen)
			window.addEventListener('touchend', touchEnd)
			window.addEventListener('touchmove', moveOnScreen)
		} else {
			menuDOMElement.classList.remove('transition-standard')
			clearTimeout(timeOutClass)
			window.removeEventListener('touchstart', touchScreen)
			window.removeEventListener('touchend', touchEnd)
			window.removeEventListener('touchmove', moveOnScreen)
		}
	})

	function touchScreen (e) {
		menuSize = menuDOMElement.offsetWidth
		mouseDown = true
		startX = e.targetTouches[0].pageX
		startY = e.targetTouches[0].pageY
		firstScroll = window.scrollY
		if (startX > 100 && menuState === false) {
			mouseDown = false
		}
	}

	function touchEnd (e) {
		if (mouseDown) {
			if (menuDOMElement.hasAttribute('style')) {
				menuDOMElement.removeAttribute('style')
			}

			if (open === 1 || open === -1) {
				if (open === 1) {
					menuDOMElement.style.transform = 'translateX(-0px)'
				} else {
					menuDOMElement.style.transform = 'translateX(-' + menuSize + 'px)'
				}

				menuState = !menuState
				if (menuState === true) {
					$('#menu').collapse('show')
					document.body.classList.add('prevent-scroll')
				} else {
					$('#menu').collapse('hide')
					document.body.classList.remove('prevent-scroll')
				}

				open = 0
			}
		}
		mouseDown = false
	}

	function moveOnScreen (e) {
		if (mouseDown) {
			moveRight = (e.targetTouches[0].pageX - startX) * 1.4
			moveBottom = (e.targetTouches[0].pageY - startY)

			if ((moveRight > 100 || moveRight < -100) && // Ruch w boki większy od 100px
				(moveBottom < 20 || moveBottom > -20) && // Ruch w dół lub góre mniejszy od 20px
				(firstScroll - window.scrollY === 0)) { // Brak scrolla
				// Scroll tylko w lewo lub prawo
				if (moveRight > 100 && menuState === true) {
					return 0
				} else if (moveRight < 0 && menuState === false) {
					return 0
				}

				// zaczynaj animację od zera (samej prawej lub lewej)
				if (moveRight < 0) {
					moveRight += menuSize + 100
				} else {
					moveRight -= 100
				}

				// Warunek nie wykraczania po za skale
				if (moveRight > menuSize) {
					moveRight = menuSize
				} else if (moveRight < 0) {
					moveRight = 0
				} else {
					open = 0
				}

				// Zamknięte -> Otwarte
				if (!menuState && moveRight > 40) {
					open = 1 // otwiera
				}

				// Otwarte -> Zamknięte
				if (menuState && moveRight < menuSize - 40) {
					open = -1
				}

				menuDOMElement.style.transition = '0s all'
				menuDOMElement.style.transform = 'translateX(-' + (menuSize - moveRight) + 'px)'
			}
		}
	}
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/script.js